exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow[data-v-736542df]{align-items:baseline}.changelog[data-v-736542df]{max-width:800px;margin:auto}.changelog[data-v-736542df]:nth-of-type(2){border-bottom:1px solid #ddd;padding-bottom:2rem;margin-bottom:2rem}.label[data-v-736542df]{width:100px}ul[data-v-736542df]{display:inline-block;margin-left:2rem;text-align:left;list-style-type:square;max-width:650px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-736542df&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/ChangelogView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-736542df&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/ChangelogView.vue
// module chunks = 0